import * as React from 'react';
import * as commonStyles from '../../common/common.module.scss';
import { PrimaryButton, SecondaryAlert } from 'kagr-ui';
import useAnnouncement from '../../../hooks/useAnnouncement';
import TinyEditor from '../../common/TinyEditor';

interface Props {
  client: number | 'global';
}

/**
 * Announcements
 * Edit view for both client-specific and global announcements.
 * @param client -- either the id of a client or 'global'
 */
const Announcements = ({ client }: Props) => {
  const { loading, announcement, errorMessage, successMessage, updateAnnouncement } = useAnnouncement(client);
  const [initialEditorValue, setInitialEditorValue] = React.useState<string>('');
  const editorRef = React.useRef(null);
  const [dirty, setDirty] = React.useState(false);

  React.useEffect(() => {
    if (!loading && announcement) {
      setInitialEditorValue(announcement);
    }
  }, [loading, announcement]);

  React.useEffect(() => {
    setDirty(false);
  }, [initialEditorValue]);

  const handleClick = () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent();
      setDirty(false);
      editorRef.current.setDirty(false);
      updateAnnouncement(client, content);
    }
  };

  return (
    <div>
      {errorMessage && <SecondaryAlert type="error" message={errorMessage} />}
      {successMessage && <SecondaryAlert type="success" message={successMessage} />}
      <TinyEditor
        editorRef={editorRef}
        initialValue={initialEditorValue}
        onDirty={() => setDirty(true)}
        disabled={loading}
      />
      <div className={commonStyles.singleFormAction}>
        <div className={commonStyles.submitButton}>
          <PrimaryButton text="Update" title="Update" handleClick={handleClick} deactive={!dirty} />
        </div>
      </div>
    </div>
  );
};

export default Announcements;
